import {
  HStack,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useCallback } from 'react';

import app from 'configs/app/app';
import IconSvg from 'ui/shared/IconSvg';
import NetworkLogo from 'ui/snippets/networkMenu/NetworkLogo';

const NetworkChangerItem = ({
  name,
  onClick,
  selected,
}: {
  name: string;
  onClick: () => void;
  selected?: boolean;
}) => {
  return (
    <HStack
      p={ 3 }
      onClick={ onClick }
      cursor={ selected ? 'default' : 'pointer' }
      _hover={
        selected ? {} : {
          '& .network-text': {
            color: 'greenFork.500',
          },
        }
      }
    >
      <NetworkLogo isCollapsed h={ 18 } mr={ 1 } opacity={ selected ? 0.8 : 1 }/>
      <Text
        className="network-text"
        fontWeight="smaller"
        color={ selected ? 'gray.500' : 'gray.100' }
      >
        { name }
      </Text>
      { selected && (
        <IconSvg name="check" boxSize={ 5 } color="gray.400" ml={ 10 }/>
      ) }
    </HStack>
  );
};

const NetworkChanger = () => {
  const { isOpen, onClose, onToggle } = useDisclosure();
  const isTestnet = app.host?.includes('testnet');

  const goToMainnet = useCallback(() => {
    const url = app.mainnetUrl;
    if (url && isTestnet) {
      window.location.href = url;
    }
  }, [ isTestnet ]);

  const goToTestnet = useCallback(() => {
    const url = app.testnetUrl;
    if (url && !isTestnet) {
      window.location.href = url;
    }
  }, [ isTestnet ]);

  return (
    <Popover
      placement="bottom-start"
      trigger="click"
      isOpen={ isOpen }
      onClose={ onClose }
    >
      <PopoverTrigger>
        <HStack
          cursor="pointer"
          _hover={{
            '& .chains-text': {
              color: 'greenFork.500',
            },
            '& .chains-icon': {
              color: 'greenFork.500',
            },
          }}
        >
          <IconButton
            variant="simple"
            aria-label="User settings"
            p="1px"
            boxSize={ 5 }
            mr={ -1 }
            onClick={ onToggle }
            icon={ (
              <IconSvg
                name="apps"
                boxSize={ 5 }
                className="chains-icon"
                color={ isOpen ? 'greenFork.500' : 'whiteFork.100' }
              />
            ) }
          />

          <Text
            fontSize="smaller"
            className="chains-text"
            onClick={ onToggle }
            color={ isOpen ? 'greenFork.500' : 'whiteFork.100' }
          >
            Chains
          </Text>

          <IconButton
            variant="simple"
            aria-label="User settings"
            p="1px"
            boxSize={ 4 }
            ml={ -1.5 }
            onClick={ onToggle }
            icon={ (
              <IconSvg
                transform="rotate(270deg)"
                name="arrows/east-mini"
                className="chains-icon"
                color={ isOpen ? 'greenFork.500' : 'whiteFork.100' }
              />
            ) }
          />
        </HStack>
      </PopoverTrigger>
      <PopoverContent overflowY="hidden" w="auto" fontSize="sm">
        <PopoverBody boxShadow="2xl" p={ 4 }>
          <Text fontWeight="semibold">Mainnets</Text>
          <NetworkChangerItem
            name="CratD2C Mainnet"
            onClick={ goToMainnet }
            selected={ !isTestnet }
          />
          <Text fontWeight="semibold">Testnets</Text>
          <NetworkChangerItem
            name="CratD2C Testnet"
            onClick={ goToTestnet }
            selected={ isTestnet }
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default React.memo(NetworkChanger);
